import React from 'react'

import { SiteContext } from 'context/site-context'

import {
  getQS,
  isWebpSupported,
} from 'helpers'

import './index.scss'

const Footer = () => {
  const [ site ] = React.useContext(SiteContext)

  const qs = () => {
    return getQS().trim().length > 0 ? `?${getQS()}` : ''
  }

  const getBanner = () => {
    const cityData = site.location && site.popular_cities.filter( c => c.label === site.location ).length > 0 ? site.popular_cities.filter( c => c.label === site.location )[0] : site.geoImages
    if(!cityData.cityImage || !cityData.cityImageWebP){
      cityData.cityImage = site.geoImages.cityImage
      cityData.cityImageWebP = site.geoImages.cityImageWebP
    }
    return cityData
  }

  return (
    <footer>
      <div className="nav-container">
        <div className="container">
          <div className="nav-bar">
            <a href={`${window.location.origin}/${site.path ? `${site.path}/about` : 'about'}${qs()}`} data-delegate="Footer">About</a>
            <a href={`${window.location.origin}/${site.path ? `${site.path}/directory` : 'directory'}${qs()}`} data-delegate="Footer">Directory</a>
            <a href={`${window.location.origin}/${site.path ? `${site.path}/privacy` : 'privacy'}${qs()}`} data-delegate="Footer">Privacy Policy</a>
            <a href={`${window.location.origin}/${site.path ? `${site.path}/privacy-california` : 'privacy-california'}${qs()}`} data-delegate="Footer">Privacy Notice for CA Residents</a>
            <a href={`${window.location.origin}/${site.path ? `${site.path}/privacy-california` : 'privacy-california'}${qs()}#do-not-sell`} data-delegate="Footer">Do Not Sell or Share My Personal Information</a>
            <a href={`${window.location.origin}/${site.path ? `${site.path}/terms` : 'terms'}${qs()}`} data-delegate="Footer">Terms of Use</a>
          </div>
        </div>
      </div>
      <div className="copyright-container">
        <div className="container">
          <aside>Copyright &copy; {new Date().getFullYear()} CityGrid Media.  All Rights Reserved.</aside>
          <div className="icons-container">
            <img src={site.logoWhite} alt="CitySearch" />
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
